"use client";

import type { Variants } from "framer-motion";
import { motion } from "framer-motion";

import ApartmentCard from "@/components/sections/Apartments/ApartmentCard";
import type { Apartment } from "@/payload-types";

export default function ApartmentList({
  apartments,
}: {
  apartments: Apartment[];
  title?: string;
  subtitle?: string;
}) {
  // Animation variants
  const containerVariants = {
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants: Variants = {
    hidden: { y: -50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <div>
      <section id="rooms" className="container mx-auto px-4 pt-0">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {/* Rooms List */}
          <div id="rooms">
            <motion.div
              className="grid grid-cols-1 gap-x-8 gap-y-12 md:grid-cols-2 xl:grid-cols-3"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              {apartments.map((apartment, index) => (
                <motion.div
                  key={apartment.id}
                  variants={itemVariants}
                  custom={index}
                  transition={{ duration: 0.3 }}
                >
                  <ApartmentCard apartment={apartment} />
                </motion.div>
              ))}
            </motion.div>
          </div>
        </motion.div>
      </section>
    </div>
  );
}
